// src/pages/Home.jsx
import { motion } from "framer-motion";
import Hero from "../components/Hero";
import StatsBar from "../components/StatsBar";
import KnowledgeHub from "../components/KnowledgeHub";
import Services from "../components/Services";
import ContactSection from "../components/ContactSection";
import { MediosAudioProvider } from "../context/MediosAudioContext";

const Home = ({ isReady }) => {
  return (
    <MediosAudioProvider>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Hero isReady={isReady} />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isReady ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <StatsBar />
          <KnowledgeHub />
          <Services />
          <ContactSection />
        </motion.div>
      </motion.div>
    </MediosAudioProvider>
  );
};

export default Home;
/*<!--© 2026 Todos los derechos reservados Desarrollado por JEMAprod-Tecnologia-->*/
